import {Matcher, TransformsOptions} from '@/lib/axiosAddTransforms'

import {Context} from '@/project'
import accessToken from './modules/access-token.request'
import accessTokenError from './modules/acess-token.error'
import auth from './matchers/auth'
import banks from './matchers/banks'
import biz from './matchers/biz'
import certificates from './matchers/certificates'
import clients from './matchers/clients'
import companies from './matchers/companies'
import dataJsonParse from './modules/data-json-parse.response'
import dataKeyRequest from './modules/data-key.request'
import dataKeyResponse from './modules/data-key.response'
import institutions from './matchers/institutions'
import invitation from './matchers/invitation'
import invoices from './matchers/invoices'
import invoicesExternal from './matchers/invoices-external'
import invoicesIssue from './matchers/invoices-issue'
import issue from './matchers/issue'
import notice from './matchers/notice'
import subsidy from './matchers/subsidy'
import taxrefund from './matchers/taxrefund'
import taxes from './matchers/taxes'
import transfer from './matchers/transfer'
import users from './matchers/users'

/**
 * Merge match list
 * @param matchers
 */
export const mergeMatchers = (matchers: Array<Matcher | Matcher[]>): Matcher[] => {
  return matchers.reduce((result: Matcher[], item: Matcher | Matcher[]) => {
    if(Array.isArray(item)) {
      result.push(...item)
    } else {
      result.push(item)
    }
    return result
  }, [])
}

export default function transformers(context: Context): TransformsOptions<Context> {
  return {
    context: () => (context),
    first: {
      request: [
        accessToken,  // Add accessToken at header/Authorization
      ],
      response: [
        dataJsonParse,  // String Json to js object
        dataKeyResponse,  // SnakeCase to camelcase
      ],
      error: [
        accessTokenError,
      ],
    },
    final: {
      request: [
        dataKeyRequest, // Camelcase to snakeCase
      ],
    },

    // Register transforming logic
    matchers: mergeMatchers([
      auth,
      companies,
      taxes,
      biz,
      certificates,
      banks,
      institutions,
      invoices,
      invoicesIssue,
      invoicesExternal,
      clients,
      transfer,
      notice,
      users,
      invitation,
      issue,
      subsidy,
      taxrefund,
    ]),
  }
}
